import React from 'react';
import ActivityFeed from '../../components/admin/ActivityFeed';
import { useAuth } from '../../context/AuthContext';
import EmptyState from '../../components/crm/EmptyState';
import { AlertCircle } from 'lucide-react';

// /admin/activity — Sprint G item 9.4 global feed (admin/ops with role scope).

export default function Activity() {
  const { user } = useAuth();
  if (user?.role !== 'nexsav_admin' && user?.role !== 'ops') {
    return (
      <div className="max-w-3xl mx-auto mt-12">
        <EmptyState icon={AlertCircle} title="Staff only" description="Activity log is restricted to NexSav staff." />
      </div>
    );
  }
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-semibold text-white tracking-tight">Activity <span className="serif-acc accent-text">log</span></h1>
        <p className="text-[13px] text-gray-500 mt-0.5">All mutations across the system. Ops view is filtered to client + ops + own activity.</p>
      </div>
      <ActivityFeed apiPath="/api/admin/activity" />
    </div>
  );
}
